import { object, array, string, collection } from '@gogame/schemas';

import { COLUMN_REGS, COLUMN_DEPOSIT_AMOUNT } from '../constants';

const chartSchema = object({
  metrics: array(string()).default([]),
});

export const newChartSchema = chartSchema.default({
  metrics: [],
});

export const chartsSchema = collection(chartSchema).default([
  {
    metrics: [COLUMN_DEPOSIT_AMOUNT],
  },
  {
    metrics: [COLUMN_REGS],
  },
]);
